import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const moreButtonStyle = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  padding: 10px 24px;
  width: 138px !important; /* BlackButton を上書き */
`;

export const moreButtonWrapperStyle = css`
  text-align: center;

  ${MEDIA_QUERY_FOR_PC} {
    margin-top: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    margin-top: 10px;
  }
`;
